import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuardService } from './auth/auth-guard.service';
import { AuthGuardAdminService } from './auth/auth-guard-admin.service';
import { CallbackComponent } from './callback/callback.component';
import { FullLayoutComponent } from './layouts/full-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout.component';
import { NoentryComponent } from 'app/noentry/noentry.component';
import { ProductsComponent } from './products/products.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
    },
    {
        path: '',
        component: FullLayoutComponent,
        data: {
            title: 'Home'
        },
        children: [
            {
                path: 'dashboard',
                loadChildren: './dashboard/dashboard.module#DashboardModule',
                canActivate: [AuthGuardAdminService]
            },
            {
                path: 'order',
                loadChildren: './order/shared/order.module#OrderModule',
                canActivate: [AuthGuardAdminService]
            },
            // {
            //     path: 'order/:param',
            //     loadChildren: './order/shared/order.module#OrderModule',
            // canActivate: [ AuthGuardAdminService ]
            // },
            {
                path: 'reports',
                loadChildren: './reports/shared/reports.module#ReportsModule',
                canActivate: [AuthGuardAdminService]
            },
            {
                path: 'forecast',
                loadChildren: './forecast/forecast.module#ForecastModule',
                canActivate: [AuthGuardAdminService]
            },
            {
                path: 'adresses',
                loadChildren: './suppliers/suppliers.module#SuppliersModule',
                canActivate: [AuthGuardAdminService]
            },
            // {
            //     path: 'rack',
            //     loadChildren: './rack/rack.module#RackModule',
            //     canActivate: [ AuthGuardAdminService ]
            // },
            {
                path: 'settings',
                loadChildren: './settings/settings.module#SettingsModule',
                canActivate: [AuthGuardAdminService]
            },
            {
                path: 'products-settings',
                component: ProductsComponent,
                data: { title: 'Products-settings' }
            }
        ],
        canActivate: [AuthGuardService]
    },
    {
        path: '',
        component: SimpleLayoutComponent,
        children: [
            {
                path: 'login',
                loadChildren: './auth/auth.module#AuthModule'
            },
            {
                path: 'callback',
                loadChildren: './callback/callback.module#CallbackModule'
            },
            {
                path: 'noentry',
                component: NoentryComponent,
                data: {
                    title: 'Noentry'
                }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts